module.exports = __webpack_public_path__ + "static/media/volume.3484312b.svg";